exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#divTemplateList {\n  padding: 20px;\n}\n\n.display-none {\n  display: none;\n}\n", ""]);

